export default function Contact() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-foreground-950">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
          <div>
            <p className="text-xs md:text-sm tracking-wider uppercase text-foreground-400 font-medium mb-6 md:mb-8">
              Contact
            </p>
            <h2 className="font-heading text-xl md:text-3xl lg:text-4xl font-light text-background-50 leading-snug mb-4 md:mb-6">
              Get in touch
              <br />
              with our team
            </h2>
            <p className="text-xs md:text-sm text-foreground-400 leading-relaxed max-w-md">
              For inquiries regarding engineering services and technical collaboration,
              please reach out through any of the channels below.
            </p>

            <div className="mt-8 md:mt-10 flex gap-4">
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border border-foreground-700 flex items-center justify-center">
                <i className="ri-mail-line text-sm md:text-base text-foreground-300"></i>
              </div>
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border border-foreground-700 flex items-center justify-center">
                <i className="ri-phone-line text-sm md:text-base text-foreground-300"></i>
              </div>
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border border-foreground-700 flex items-center justify-center">
                <i className="ri-map-pin-line text-sm md:text-base text-foreground-300"></i>
              </div>
            </div>
          </div>

          <div className="space-y-6 md:space-y-8">
            <div>
              <p className="text-xs tracking-wider uppercase text-foreground-500 font-medium mb-2">
                Address
              </p>
              <p className="text-sm md:text-base text-background-50 leading-relaxed">
                Perkunkiemio g. 19
                <br />
                Vilnius, 12120
                <br />
                Lithuania
              </p>
            </div>

            <div>
              <p className="text-xs tracking-wider uppercase text-foreground-500 font-medium mb-2">
                Phone
              </p>
              <p className="text-sm md:text-base text-background-50">
                +370 66806244
              </p>
            </div>

            <div>
              <p className="text-xs tracking-wider uppercase text-foreground-500 font-medium mb-2">
                Email
              </p>
              <p className="text-sm md:text-base text-background-50">
                ceo@projekturemai.com
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-6 md:pt-8 border-t border-foreground-800 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} PROJEKTU REMAI, MB. All rights reserved.
          </p>
          <div className="flex gap-6">
            <span className="text-xs text-foreground-500">Engineering</span>
            <span className="text-xs text-foreground-500">iOS Platform</span>
            <span className="text-xs text-foreground-500">Vilnius</span>
          </div>
        </div>
      </div>
    </section>
  );
}